import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function fetchStats() {
  const { data } = await api.get("/stats");
  return data;
}

export async function fetchDonors(limit = 50) {
  const { data } = await api.get("/donors", { params: { limit } });
  return data;
}

export async function createCheckout(payload) {
  const { data } = await api.post("/checkout/session", payload);
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
}
